// LoadingSpinner.jsx
import React from 'react';

export default function LoadingSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-offwhite">
      <div className="flex flex-col items-center gap-4">
        <div className="relative w-14 h-14">
          <div className="absolute inset-0 border-2 border-primary-200 rounded-full" />
          <div className="absolute inset-0 border-2 border-transparent border-t-primary-600 rounded-full animate-spin" />
        </div>
        <div className="font-display text-xl text-charcoal tracking-widest">RAGVI</div>
      </div>
    </div>
  );
}
